<template>
    <div id="artist-info">
        <div class="row" v-if="respondedArtist.length > 0">
            <!--        <div class="row">-->
            <div v-for="(record, index) in totalResponseArtist" :key="index" class="col-12 js-preloader-artist">
                <div class="card-container" v-if="record.status === 0 || record.status === 1">
                    <div class="card-info">
                        <div class="card-info-photo position-relative">
                            <a @click="openArtistProfile(record.artist.artist_info.slug)"
                               class="text-decoration-none show-artist-link" @mouseenter="handleMouseEnter">
                                <img :src="record.artist.artist_info.main_avatar" alt="Artist photo"
                                     class="img-fluid js-profile-img card-info-photo__img">
                            </a>
                            <div class="flag-artist" v-if="record.flag === 1">
                                <img :src="getIcon() + 'save-later.png'" alt="Flag">
                            </div>
                        </div>
                        <div class="card-info-description">
                            <h3 class="mb-0 mt-1 text-uppercase">{{ record.artist.artist_info.hide_band_name }}</h3>
                            <div v-if="record.artist.avg_reviewers > 0" class="card-info-description-stars">
                                <img :src="getIcon() + 'dashboard-rate-star.svg'" width="30" alt="star">
                                <span class="main-text text-muted px-2">{{ record.artist.avg_reviewers }} stars</span>
                            </div>
                            <p class="text-muted main-text word-break">
                                {{ record.artist.artist_info.hide_short_biography }}
                            </p>
                            <p class="main-text-bold">
                                #{{ record.artist.artist_info.first_genre }}
                            </p>
                        </div>
                    </div>
                    <div class="card-carts bid d-none d-xl-flex">
                        <div class="card-carts-block">
                            <div class="card-carts-block-header">
                                <img class="img-fluid icon" :src="getIcon() + 'result-search/fans.png'" alt="fans">
                                <h3>FANS</h3>
                            </div>
                            <div class="card-carts-block-body ms-2">
                                <div>
                                    <p class="card-carts-block-number">{{
                                            record.artist.artist_info.format_followers
                                        }}</p>
                                    <div>
                                        <span class="card-carts-block-muted">Fan size</span>

                                        <img :src="getIcon() + 'info.svg'" class="mb-2 cursor-info" alt="fan size"
                                             data-bs-toggle="tooltip" data-bs-placement="top"
                                             title="Total number of Fans across all analyzed social media platform.">
                                    </div>

                                </div>
                                <hr>
                                <div>
                                    <p class="card-carts-block-number">{{ record.artist.artist_info.percent_cult_score }}</p>
                                    <div>
                                        <span class="card-carts-block-muted">Cult-Following Score</span>
                                        <img :src="getIcon() + 'info.svg'" class="mb-2 cursor-info" alt="fan size"
                                             data-bs-toggle="tooltip" data-bs-placement="top"
                                             title="Rating from 1 - 5 detailing how engaged fans are with the artist on social media.  The higher the score the better.">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card-carts-block">
                            <div class="card-carts-block-header">
                                <img class="img-fluid icon" :src="getIcon() + 'result-search/rank.png'" alt="rank">
                                <h3>RANK<img :src="getIcon() + 'info.svg'" class="ms-1 mb-1 cursor-info" width="15"
                                             alt="fan size"
                                             data-bs-toggle="tooltip" data-bs-placement="top"
                                             title="Hedlyner ranks that are awarded to Artists that perform great Shows.">
                                </h3>
                            </div>
                            <div class="card-carts-block-body mt-md-4">
                                <p class="ranking-name" v-for="(rank, index) in record.artist.ranks" :key="index">
                                    <span class="ranking-name-border">{{ rank.name }}</span>
                                </p>
                            </div>
                        </div>
                        <div class="card-audios js-audios-container vue-audios" @mouseenter="onAudioEnter">
                            <div v-for="(audio, idx) in record.artist.audios" :key="idx" class="row pb-1">
                                <div class="col-12 artist-audio custom-audio-element" :data-audio-idx="idx">
                                    <div class="card shadow border-10 border-0">
                                        <div class="px-3 py-1 bg-yellow audio-header">
                                            <span class="main-text-bold">{{ audio.title }}</span>
                                        </div>

                                        <div class="card-body py-1" style="height: 43px">
                                            <audio hidden class="d-none" :data-audio-idx="idx">
                                                <source :src="audio.url" type="audio/mp3">
                                            </audio>

                                            <div class="row justify-content-between align-items-center h-100">
                                                <div
                                                    class="col-3 col-md-5 col-lg-6 col-xl-6 col-xxl-5 d-flex justify-content-start p-0 ps-1 align-items-center">
                                                    <button class="btn p-0 audio-btn js-prev-audio-btn">
                                                        <img class="img-fluid" :src="getIcon() + 'audio/prev-audio.svg'"
                                                             alt="prev">
                                                    </button>

                                                    <button
                                                        class="btn btn-without-focus btn-profile-sound js-profile-btn btn-profile-sound-play play js-play-audio"></button>

                                                    <button class="btn p-0 audio-btn js-next-audio-btn">
                                                        <img class="img-fluid" :src="getIcon() + 'audio/next-audio.svg'"
                                                             alt="next">
                                                    </button>
                                                </div>

                                                <div
                                                    class="h-100 col-9 col-md-7 col-lg-6 col-xl-6 col-xxl-7 ps-0 d-flex align-items-center">
                                                    <input type="range" class="w-100 js-audio-progress" value="0"
                                                           max="100" min="0">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-bids row">
                        <div class="col-12 mb-1">
                            <p class="mb-1 price">${{ record.counter_offer }}</p>
                            <div v-if="record.counter_offer !== bid.budget ">
                                <img :src="getIcon() + 'flag.png'" alt="Flag">
                                <span class="main-text-bold">Artist Counteroffer</span>
                            </div>
                        </div>
                        <div class="col-12">
                            <div v-if="record.formatted_extra_requirements">
                                <p class="main-text-bold">Extra requirements
                                    <img :src="getIcon() + 'info.svg'" class="ms-1 mb-1 cursor-info" width="15"
                                         alt="fan size" data-bs-toggle="tooltip" data-bs-placement="top"
                                         :title="record.formatted_extra_requirements">
                                </p>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="mb-1">
                                <img :src="getIcon() + 'accept.png'" alt="accept" class="action-bid me-2"
                                     @click="acceptArtist(record)">
                                <span class="main-text text-muted">Accept</span>
                            </div>
                            <div class="mb-1" v-if="record.flag === 0">
                                <img :src="getIcon() + 'save-later.png'" alt="accept" class="action-bid me-2"
                                @click="saveForLaterArtist(record)">
                                <span class="main-text text-muted">Save for later</span>
                            </div>
                            <div class="mb-1">
                                <img :src="getIcon() + 'decline.png'" alt="decline" class="action-bid me-2"
                                     @click="declineArtist(record)">
                                <span class="main-text text-muted">Decline for this bid</span>
                            </div>
                            <div class="mb-1">
                                <img :src="getIcon() + 'flag.png'" alt="decline" class="action-bid me-2 ms-2"
                                     @click="declineForAllBidsArtist(record)">
                                <span class="main-text text-muted">Decline for all bids</span>
                            </div>
                            <div class="mb-1">
                                <img :src="'/images/user/bid/trash.png'" alt="decline" class="action-bid me-2 ms-2"
                                     @click="ignoreArtist(record)">
                                <span class="main-text text-muted">Ignore this artist</span>
                            </div>
                            <div class="mb-1">
                                <img :src="getIcon() + 'flag.png'" alt="decline" class="action-bid me-2 ms-2"
                                     @click="openArtistOffer(record)">
                                <span class="main-text text-muted">Review Offer</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-center mt-4" v-if="showLoadMoreBtn">
                <button @click="allArtistPage" class="button-text btn text-white bg-purple btn-shadow border-50">
                    Load More</button>
            </div>
        </div>
        <div v-else class="mt-3 text-center">
            <h3>Tip: Increase your budget to see more requests from artists.</h3>
        </div>
    </div>
</template>

<script>
import {Tooltip} from "bootstrap";
import {notification} from "../../helpers/notification";
const Swal = require('sweetalert2');
new Tooltip(document.body, {
    selector: "[data-bs-toggle='tooltip']",
});
export default {
    name: "artist-info",
    props: ['bid'],
    data() {
        return {
            url: '/events/manage',
            bidUrl: '/event/manage',
            respondedArtist: this.bid.responded_artist,
        }
    },
    mounted() {
        this.getArtists(this.bid)
    },

    methods: {

        getArtists(bid) {
            let vm = this;
            axios.get(vm.url + '/' + bid.id + '/artists').then(function (response) {
                vm.respondedArtist = response.data.data
            })
        },

        acceptArtist(record) {
            let vm = this;
            axios.post(vm.bidUrl + '/' + record.id + '/accept').then(function (response) {
                location.href = response.data.url;
            })
        },

        saveForLaterArtist(record) {
            let vm = this;
            Swal.fire({
                heightAuto: false,
                html:
                    'Are you sure you want save for later Artist?',
                showCancelButton: true,
                cancelButtonText: 'No',
                confirmButtonText: 'Yes',
            }).then(result => {
                if (result.value) {
                    $('.js-preloader-artist').addClass('preloader-div')
                    axios.put(vm.bidUrl + '/' + record.id + '/save-for-later').then(function (response) {
                        vm.getArtists(response.data.bid)
                        $('.js-preloader-artist').removeClass('preloader-div')
                    })
                }
            });
        },

        ignoreArtist(record) {
            let vm = this;
            Swal.fire({
                heightAuto: false,
                html:
                    'Are you sure you want ignore this Artist?',
                showCancelButton: true,
                cancelButtonText: 'No',
                confirmButtonText: 'Yes',
            }).then(result => {
                if (result.value) {
                    $('.js-preloader-artist').addClass('preloader-div')
                    axios.put(vm.bidUrl + '/' + record.id + '/ignore-artist').then(function (response) {
                        notification('success', response.data.message);
                        $('.js-preloader').removeClass('preloader-div')
                        setTimeout(() => window.location.reload(), 2000);
                    })
                }
            });
        },

        declineArtist(record) {
            let vm = this;
            $('.js-preloader-artist').addClass('preloader-div')
            axios.put(vm.bidUrl + '/' + record.id + '/decline').then(function (response) {
                vm.getArtists(response.data.bid)
                $('.js-preloader-artist').removeClass('preloader-div')
            })
        },

        declineForAllBidsArtist(record) {
            let vm = this;
            $('.js-preloader-artist').addClass('preloader-div')
            axios.put(vm.bidUrl + '/' + record.id + '/decline-all').then(function (response) {
                notification('success', response.data.message);
                $('.js-preloader').removeClass('preloader-div')
                setTimeout(() => window.location.reload(), 2000);
            })
        },

        openArtistProfile(slug) {
            window.open('/artists/' + slug, '_blank');
        },

        openArtistOffer(record) {
            window.open('/artist-offer/' + record.id, '_blank');
        },

        getIcon() {
            return '/images/icons/';
        },
        allArtistPage () {
            window.open('/event/manage/show/all-venue-bids', '_blank');
            localStorage.setItem('bidId', this.bid.id)
        },
        onAudioEnter() {
            window.__initAudioElements()
            window.__pauseOtherAudios()
        },
        handleMouseEnter(event) {
            const target = event.target
            const profileImg = target.querySelector('.js-profile-img')
            profileImg.classList.add('card-info-photo__img-hover')
        },
        handleMouseLeave(event) {
            const target = event.target
            const profileImg = target.querySelector('.js-profile-img')
            profileImg.classList.remove('card-info-photo__img-hover')
        }
    },
    computed: {
        totalResponseArtist () {
            return this.respondedArtist.slice(0, 5)
        },
        showLoadMoreBtn () {
            return this.respondedArtist.length >= 5
        }
    }
}
</script>
